// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tim-row {
  margin-bottom: 20px;
}

/*      transitions */

.presentation-page .front,
.presentation-page .front:after,
.presentation-page .front .btn,
.logo-container .logo,
.logo-container .brand {
  transition: all .2s;
}

.bd-docs .navbar .navbar-nav {
  margin-top: 0;
}

.section-notifications .container-fluid {
  padding: 0;
}

@media screen and (max-width: 576px) {
  .section-notifications .container-fluid {
    padding-right: 15px;
    padding-left: 15px;
  }
}

.presentation-page {
  /*       Loading dots  */
}

.presentation-page .loader {
  opacity: 0;
  display: block;
  transition: all 0.4s;
  -webkit-transition: all 0.4s;
  position: fixed;
  left: 50%;
  top: 50%;
  z-index: 1031;
  margin-left: -32px;
  margin-top: -32px;
}

.presentation-page .section-basic-components,
.presentation-page .section-testimonials {
  overflow: hidden;
}

.presentation-page .loader.visible {
  display: block;
  opacity: 1;
}

.presentation-page .modal-content {
  background-color: transparent;
  box-shadow: 0 0 0;
}

.presentation-page .modal-backdrop.in {
  opacity: 0.45;
}

.presentation-page .preload-image {
  display: none;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.15), 0 0 1px 1px rgba(0, 0, 0, 0.1);
}

.presentation-page .section-components .col-md-3 {
  max-width: 16%;
  padding-left: 100px;
}

.presentation-page .section-icons {
  padding: 180px 0;
}

.presentation-page .section-icons [class*="col-"]:nth-child(2) {
  padding: 0 70px;
}

.presentation-page .section-icons[data-background-color="black"] {
  background-color: #777777;
}

.presentation-page .section-icons .icons-nucleo {
  width: 100%;
  height: 100%;
  position: relative;
  top: -48px;
}

.presentation-page .section-icons .icons-nucleo .now-ui-icons {
  position: absolute;
  color: #fff;
  transform: translate3D(0px, 50px, 0px);
  -webkit-transform: translate3D(0px, 50px, 0px);
  transition: all 0.6s cubic-bezier(0.34, 2, 0.7, 1) 0s;
}

.presentation-page .section-icons .icons-nucleo .first-left-icon {
  top: -25%;
  left: 10%;
  font-size: 65px;
}

.presentation-page .section-icons .icons-nucleo .second-left-icon {
  top: 0%;
  left: 45%;
  font-size: 35px;
}

.presentation-page .section-icons .icons-nucleo .third-left-icon {
  top: 30%;
  left: 65%;
  font-size: 25px;
}

.presentation-page .section-icons .icons-nucleo .fourth-left-icon {
  top: 70%;
  left: 10%;
  font-size: 50px;
}

.presentation-page .section-icons .icons-nucleo .fifth-left-icon {
  top: 45%;
  left: 30%;
  font-size: 40px;
}

.presentation-page .section-icons .icons-nucleo .sixth-left-icon {
  top: 120%;
  left: 35%;
  font-size: 40px;
}

.presentation-page .section-icons .icons-nucleo .seventh-left-icon {
  top: 35%;
  left: 85%;
  font-size: 45px;
}

.presentation-page .section-icons .icons-nucleo .eighth-left-icon {
  top: 90%;
  left: 55%;
  font-size: 30px;
}

.presentation-page .section-icons .icons-nucleo .ninth-left-icon {
  top: 40%;
  left: 5%;
  font-size: 40px;
}

.presentation-page .section-icons .icons-nucleo .tenth-left-icon {
  top: 75%;
  left: 80%;
  font-size: 35px;
}

.presentation-page .section-icons .icons-nucleo .first-right-icon {
  top: -25%;
  right: 10%;
  font-size: 65px;
}

.presentation-page .section-icons .icons-nucleo .second-right-icon {
  top: 0%;
  right: 45%;
  font-size: 35px;
}

.presentation-page .section-icons .icons-nucleo .third-right-icon {
  top: 30%;
  right: 65%;
  font-size: 25px;
}

.presentation-page .section-icons .icons-nucleo .fourth-right-icon {
  top: 70%;
  right: 10%;
  font-size: 50px;
}

.presentation-page .section-icons .icons-nucleo .fifth-right-icon {
  top: 45%;
  right: 30%;
  font-size: 40px;
}

.presentation-page .section-icons .icons-nucleo .sixth-right-icon {
  top: 120%;
  right: 35%;
  font-size: 35px;
}

.presentation-page .section-icons .icons-nucleo .seventh-right-icon {
  top: 35%;
  right: 88%;
  font-size: 30px;
}

.presentation-page .section-icons .icons-nucleo .eighth-right-icon {
  top: 90%;
  right: 55%;
  font-size: 35px;
}

.presentation-page .section-icons .icons-nucleo .ninth-right-icon {
  top: 40%;
  right: 5%;
  font-size: 40px;
}

.presentation-page .section-icons .icons-nucleo .tenth-right-icon {
  top: 75%;
  right: 80%;
  font-size: 35px;
}

.presentation-page .section-cards .image-container1,
.presentation-page .section-cards .image-container2,
.presentation-page .section-cards .image-container3,
.presentation-page .section-cards .image-container4,
.presentation-page .section-cards .image-container5 {
  display: inline-block;
  position: relative;
  box-shadow: 0px 5px 25px 0px rgba(0, 0, 0, 0.2);
  border-radius: 0.1875rem;
  overflow: hidden;
}

.presentation-page .section-cards .image-container1 {
  left: 48px;
}

.presentation-page .section-cards .image-container5 {
  right: 48px;
}

.presentation-page .section-cards .image-container2 {
  left: 25px;
}

.presentation-page .section-cards .image-container4 {
  right: 25px;
}

.presentation-page .section-cards .images-container {
  height: 100%;
  margin: 0 auto;
  text-align: center;
  margin-top: 60px;
}

.presentation-page .section-cards .image-container1,
.presentation-page .section-cards .image-container5 {
  width: 16%;
  top: -53px;
  z-index: 1;
}

.presentation-page .section-cards .image-container2,
.presentation-page .section-cards .image-container4 {
  width: 22%;
  top: -27px;
  z-index: 2;
}

.presentation-page .section-cards .image-container3 {
  width: 22%;
  z-index: 3;
}

.presentation-page .section-cards+.section-content {
  padding-top: 480px;
  padding-bottom: 30px;
  margin-top: -277px;
}

.presentation-page .page-header+.section-components {
  padding-top: 300px;
}

.presentation-page .colors {
  padding: 100px 0;
}

.presentation-page>.description {
  padding-top: 20px;
}

.presentation-page .section-rotation {
  padding: 140px 0;
}

.presentation-page .section-images {
  padding: 80px 0;
}

.presentation-page .section-thin {
  padding: 0;
}

.presentation-page .section-pay {
  padding-top: 20px;
}

.presentation-page .colors {
  padding: 70px 0;
  z-index: 7;
  position: relative;
  margin-top: -300px;
}

.presentation-page .colors {
  border-top: 1px solid #DDDDDD;
}

.presentation-page .card-container {
  -o-perspective: 900px;
  perspective: 900px;
  width: 300px;
  position: relative;
  margin-top: 90px;
}

.presentation-page .card-component {
  transform-style: preserve-3d;
  position: relative;
  height: 500px;
}

.presentation-page .card-component .front {
  backface-visibility: hidden;
  transform: rotateY(-35deg);
  position: absolute;
  top: 0;
  left: 0;
  background-color: #FFF;
  width: 100%;
  cursor: pointer;
  box-shadow: 10px 4px 14px rgba(0, 0, 0, 0.12);
  border-radius: 10px;
  overflow: hidden;
}

.presentation-page h5.description {
  margin-top: 35px;
}

.presentation-page .category {
  text-transform: uppercase;
}

.presentation-page .section-basic-components {
  padding: 190px 0;
}

.presentation-page .section-basic-components .title {
  margin-top: 60px;
}

.presentation-page .section-basic-components .image-container {
  height: 380px;
  position: relative;
}

.presentation-page .section-basic-components .image-container .components-macbook {
  width: auto;
  left: 100px;
  top: 0;
  height: auto;
  position: absolute;
}

.presentation-page .section-basic-components .image-container .table-img,
.presentation-page .section-basic-components .image-container .share-btn-img,
.presentation-page .section-basic-components .image-container .coloured-card-btn-img,
.presentation-page .section-basic-components .image-container .coloured-card-img,
.presentation-page .section-basic-components .image-container .social-img,
.presentation-page .section-basic-components .image-container .linkedin-btn-img {
  position: absolute;
  box-shadow: 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12), 0 5px 5px -3px rgba(0, 0, 0, 0.2);
}

.presentation-page .section-basic-components .image-container .table-img {
  left: 65%;
  top: 23%;
  height: 175px;
  border-radius: 3px;
}

.presentation-page .section-basic-components .image-container .share-btn-img {
  left: 83%;
  top: 95%;
  height: 25px;
  border-radius: 10px;
}

.presentation-page .section-basic-components .image-container .coloured-card-img {
  left: 50%;
  top: -11%;
  height: 102px;
  border-radius: 3px;
}

.presentation-page .section-basic-components .image-container .coloured-card-btn-img {
  left: -3%;
  top: 42%;
  height: 133px;
  border-radius: 3px;
}

.presentation-page .section-basic-components .image-container .social-img {
  left: -4%;
  top: 95%;
  height: 57px;
}

.presentation-page .section-basic-components .image-container .linkedin-btn-img {
  left: 3%;
  top: -3%;
  height: 25px;
  border-radius: 10px;
}

.presentation-page .section-components+.section {
  margin-top: -270px;
  z-index: 7;
  position: relative;
  border-top: 1px solid rgba(231, 231, 231, 0.5);
}

.presentation-page .info {
  max-width: 410px;
}

.presentation-page .section-free-demo {
  overflow: hidden;
}

.presentation-page .section-free-demo .github-buttons>.btn {
  float: left;
  margin-right: 15px;
}

.presentation-page .section-free-demo .github-buttons .github-button {
  float: left;
  margin-top: 15px;
}

.presentation-page .section-free-demo .github-background-container {
  position: absolute;
  right: -420px;
  top: -50px;
}

.presentation-page .section-free-demo .github-background-container i {
  font-size: 810px;
  opacity: .1;
}

.presentation-page .section-sections {
  overflow: hidden;
  padding-top: 200px;
}

.presentation-page .section-sections .container-fluid {
  z-index: 1;
}

.presentation-page .section-sections .container-fluid img {
  position: relative;
  z-index: 2;
}

.presentation-page .section-examples {
  margin-top: -125px;
}

.presentation-page .section-examples .section-description {
  margin-top: 100px;
}

.presentation-page .section-testimonials {
  padding-bottom: 0;
}

.presentation-page .section-testimonials[data-background-color="black"] {
  background: #181818;
}

.presentation-page .section-testimonials .carousel .card {
  margin: 40px auto;
}

.presentation-page .section-testimonials .testimonials-people {
  margin-top: -100px;
}

.presentation-page .section-pricing .our-clients {
  margin-bottom: 100px;
  margin-top: 50px;
}

.presentation-page .section-pricing .our-clients img {
  width: 100%;
  max-width: 120px;
  margin: 0 30px;
  display: inline-block;
}

.presentation-page .section-sharing span {
  margin-top: 30px;
  display: block;
}

.presentation-page .section-sharing .fa-pay {
  font-size: 30px;
  display: inline-block;
  margin: 5px 1px 0;
  width: auto;
}

.presentation-page .section-components {
  z-index: 1;
}

.presentation-page .front img {
  z-index: 2;
  position: relative;
}

.presentation-page .card-component img {
  width: 100%;
}

.presentation-page .description .col-md-3 {
  width: 16%;
  margin-left: 4%;
}

.presentation-page .first-card {
  z-index: 6;
}

.presentation-page .second-card {
  z-index: 5;
}

.presentation-page .third-card {
  z-index: 4;
}

.presentation-page .fourth-card {
  z-index: 3;
}

.presentation-page .section-gray h1 small {
  color: #888888;
}

.presentation-page .color-container {
  text-align: center;
}

.presentation-page .color-container img {
  width: 100%;
  margin-bottom: 10px;
}

.presentation-page .circle-color {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: block;
  background-color: #cccccc;
  margin: 0 auto;
}

.presentation-page .circle-red {
  background-color: #ff3b30;
}

.presentation-page .circle-blue {
  background-color: #3472f7;
}

.presentation-page .circle-azure {
  background-color: #2ca8ff;
}

.presentation-page .circle-green {
  background-color: #05ae0e;
}

.presentation-page .circle-orange {
  background-color: #ff9500;
}

.presentation-page .rellax-text-container,
.index-page .rellax-text-container {
  max-width: 1003px;
  margin: 0 auto;
  text-align: center;
  position: relative;
  top: 24%;
}

.presentation-page .rellax-text-container .h1-seo,
.index-page .rellax-text-container .h1-seo {
  font-size: 16.8em;
  text-transform: uppercase;
  font-weight: 700;
  font-family: 'Open Sans Condensed', sans-serif;
  z-index: 1;
  letter-spacing: -10px;
  text-align: center;
  background: #ffedea;
  background: linear-gradient(to bottom, #FFFFFF 35%, #c38775 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.presentation-page .rellax-text-container .pro,
.index-page .rellax-text-container .pro {
  position: absolute;
  font-size: 20px;
  background: #132026;
  padding: 6px 10px;
  border-radius: 4px;
  top: 41px;
  font-weight: 600;
  margin-top: 10px;
  right: -78px;
}

.presentation-page .n-logo,
.index-page .n-logo {
  max-width: 100px;
  margin-bottom: 40px;
}

.presentation-page .page-header-city,
.index-page .page-header-city {
  background-size: cover;
  background-position: top;
  top: 25.5%;
  background-repeat: no-repeat;
}

.presentation-page .h3-description,
.index-page .h3-description {
  z-index: 3;
  top: 50%;
  position: absolute;
  width: 100%;
  text-align: center;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.71);
}

.presentation-page .category-absolute,
.index-page .category-absolute {
  z-index: 3;
}

.presentation-page .rellax-header,
.index-page .rellax-header {
  position: absolute;
  height: 100%;
  width: 100%;
}

.presentation-page .rellax-header-sky,
.index-page .rellax-header-sky {
  z-index: 0;
  height: 50%;
}

.presentation-page .rellax-header-buildings,
.index-page .rellax-header-buildings {
  z-index: 2;
}

.presentation-page [data-background-color="dark-red"],
.index-page [data-background-color="dark-red"] {
  background: #220c08;
}

.presentation-page .page-header,
.index-page .page-header {
  background: #d0aea8;
}

.index-page .rellax-text-container {
  top: 22%;
}

.index-page .rellax-text-container .h1-seo {
  letter-spacing: -3px;
  font-size: 10.3em;
}

.tim-white-buttons {
  background-color: #777777;
}

.typography-line {
  padding-left: 25%;
  margin-bottom: 35px;
  position: relative;
  display: block;
  width: 100%;
}

.typography-line span {
  bottom: 10px;
  color: #c0c1c2;
  display: block;
  font-weight: 400;
  font-size: 13px;
  line-height: 13px;
  left: 0;
  margin-left: 20px;
  position: absolute;
  width: 260px;
  text-transform: none;
}

.tim-row {
  padding-top: 60px;
}

.tim-row h3 {
  margin-top: 0;
}

.switch {
  margin-right: 20px;
}

#navbar-full .navbar {
  border-radius: 0 !important;
  margin-bottom: 15px;
  z-index: 2;
}

#menu-dropdown .navbar {
  border-radius: 3px;
}

#pagination-row .pagination-container {
  height: 100%;
  max-height: 100%;
  display: flex;
  align-items: center;
}

#icons-row i.now-ui-icons {
  font-size: 30px;
}

.space {
  height: 130px;
  display: block;
}

.space-110 {
  height: 110px;
  display: block;
}

.space-50 {
  height: 50px;
  display: block;
}

.space-70 {
  height: 70px;
  display: block;
}

.navigation-example .img-src {
  background-attachment: scroll;
}

.navigation-example {
  background-position: center center;
  background-size: cover;
  margin-top: 0;
  min-height: 740px;
  height: 100%;
}

#notifications {
  background-color: #FFFFFF;
  display: block;
  width: 100%;
  position: relative;
}

.tim-note {
  text-transform: capitalize;
}

#buttons .btn,
#javascriptComponents .btn {
  margin: 0 0px 10px;
}

.space-100 {
  height: 100px;
  display: block;
  width: 100%;
}

.be-social {
  padding-bottom: 20px;
  /*     border-bottom: 1px solid #aaa; */
  margin: 0 auto 40px;
}

.txt-white {
  color: #FFFFFF;
}

.txt-gray {
  color: #ddd !important;
}

.parallax {
  width: 100%;
  height: 570px;
  display: block;
  background-attachment: fixed;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
}

.logo-container .logo {
  overflow: hidden;
  border-radius: 50%;
  border: 1px solid #333333;
  width: 50px;
  float: left;
}

.logo-container .brand {
  font-size: 16px;
  color: #FFFFFF;
  line-height: 18px;
  float: left;
  margin-left: 10px;
  margin-top: 7px;
  width: 70px;
  height: 40px;
  text-align: left;
}

.logo-container .brand-material {
  font-size: 18px;
  margin-top: 15px;
  height: 25px;
  width: auto;
}

.logo-container .logo img {
  width: 100%;
}

.navbar-small .logo-container .brand {
  color: #333333;
}

.fixed-section {
  top: 90px;
  max-height: 80vh;
  overflow: scroll;
  position: sticky;
}

.fixed-section ul {
  padding: 0;
}

.fixed-section ul li {
  list-style: none;
}

.fixed-section li a {
  font-size: 14px;
  padding: 2px;
  display: block;
  color: #666666;
}

.fixed-section li a.active {
  color: #00bbff;
}

.fixed-section.float {
  position: fixed;
  top: 100px;
  width: 200px;
  margin-top: 0;
}

.parallax .parallax-image {
  width: 100%;
  overflow: hidden;
  position: absolute;
}

.parallax .parallax-image img {
  width: 100%;
}

@media (max-width: 768px) {
  .parallax .parallax-image {
    width: 100%;
    height: 640px;
    overflow: hidden;
  }
  .parallax .parallax-image img {
    height: 100%;
    width: auto;
  }
}

.social-buttons-demo .btn {
  margin-right: 5px;
  margin-bottom: 7px;
}

.img-container {
  width: 100%;
  overflow: hidden;
}

.img-container img {
  width: 100%;
}

.lightbox img {
  width: 100%;
}

.lightbox .modal-content {
  overflow: hidden;
}

.lightbox .modal-body {
  padding: 0;
}

@media screen and (min-width: 991px) {
  .lightbox .modal-dialog {
    width: 960px;
  }
}

@media screen and (max-width: 576px) {
  .index-page .typography-line span {
    margin-left: 0;
  }
  .presentation-page .section-cards+.section-content {
    padding-top: 70px;
    margin-top: 0;
  }
  .presentation-page .rellax-text-container .pro {
    bottom: 84px;
    top: initial;
    font-size: 13px;
    right: 55px;
  }
  .presentation-page .section-components .col-md-3 {
    max-width: inherit;
  }
  .presentation-page .card-container {
    margin: 0 auto;
  }
  .presentation-page .card-container .card-component .front {
    transform: rotateY(0deg);
  }
  .presentation-page .rellax-text-container .h1-seo,
  .presentation-page .index-page .h1-seo {
    background: linear-gradient(to bottom, #FFFFFF 64%, #c38775 100%);
    -webkit-background-clip: text;
    font-size: 8.4em;
  }
  .presentation-page .rellax-text-container,
  .index-page .rellax-text-container {
    top: 21%;
    max-width: 360px;
  }
  .index-page .rellax-text-container {
    top: 25%;
  }
  .index-page .rellax-text-container .h1-seo {
    font-size: 3.8em;
  }
}

@media only screen and (min-device-width: 375px) and (max-device-width: 667px) {
  .presentation-page .rellax-text-container {
    top: 20% !important;
  }
  .presentation-page .page-header+.section-components {
    padding-top: 200px;
  }
}

@media only screen and (min-device-width: 375px) and (max-device-width: 667px) and (orientation: portrait) {
  .presentation-page .rellax-text-container {
    top: 17% !important;
  }
}

@media screen and (max-width: 768px) and (min-width: 576px) {
  .presentation-page .rellax-text-container,
  .index-page .rellax-text-container {
    max-width: 565px;
    top: 33%;
  }
  .index-page .rellax-text-container {
    top: 26%;
  }
  .presentation-page .rellax-text-container .h1-seo {
    font-size: 9.3em;
  }
  .index-page .rellax-text-container .h1-seo {
    font-size: 5.6em;
  }
  .presentation-page .rellax-text-container .pro {
    font-size: 12px;
    top: -14px;
    right: 2px;
  }
}

@media screen and (max-width: 991px) and (min-width: 768px) {
  .presentation-page .rellax-text-container,
  .index-page .rellax-text-container {
    max-width: 730px;
    top: 32%;
  }
  .index-page .rellax-text-container {
    top: 24%;
  }
  .presentation-page .rellax-text-container .pro {
    font-size: 14px;
    top: 18px;
    right: -3px;
  }
  .presentation-page .rellax-text-container .h1-seo {
    font-size: 10.8em;
  }
  .index-page .rellax-text-container .h1-seo {
    font-size: 6.9em;
  }
}

@media screen and (min-width: 768px) {
  .presentation-page .card-container:hover .front {
    top: -80px;
  }
  .presentation-page .section-content .image-container {
    height: 400px;
  }
  .presentation-page .section-content .image-container img {
    position: absolute;
    width: 100%;
    max-width: 380px;
  }
  .presentation-page .section-content .image-container .img-blog {
    z-index: 4;
    left: 100px;
    top: 20px;
  }
  .presentation-page .section-content .image-container .img-comments {
    z-index: 3;
    left: -100px;
    top: -40px;
  }
}

@media (max-width: 991px) {
  .fixed-section.affix {
    position: relative;
    margin-bottom: 100px;
  }
  .presentation-page .section-cards .image-container1,
  .presentation-page .section-cards .image-container5 {
    width: 15%;
    top: -75px;
  }
  .presentation-page .section-cards .image-container2,
  .presentation-page .section-cards .image-container4 {
    width: 21%;
    top: -62px;
  }
  .presentation-page .section-cards .image-container3 {
    width: 22%;
    top: -45px;
  }
}

@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  .presentation-page .section-icons .icons-nucleo {
    position: initial;
  }
  .presentation-page .third-right-icon,
  .presentation-page .fourth-right-icon,
  .presentation-page .fifth-right-icon,
  .presentation-page .sixth-right-icon,
  .presentation-page .seventh-right-icon,
  .presentation-page .eighth-right-icon,
  .presentation-page .ninth-right-icon,
  .presentation-page .tenth-right-icon,
  .presentation-page .second-left-icon,
  .presentation-page .third-left-icon,
  .presentation-page .fifth-left-icon,
  .presentation-page .sixth-left-icon,
  .presentation-page .eighth-left-icon,
  .presentation-page .fourth-left-icon,
  .presentation-page .ninth-left-icon,
  .presentation-page .tenth-left-icon {
    display: none;
  }
  .presentation-page .section-icons .icons-nucleo .first-right-icon,
  .presentation-page .section-icons .icons-nucleo .first-left-icon {
    top: -15%;
  }
  .presentation-page .section-icons .icons-nucleo .second-right-icon {
    top: 35%;
    right: 80%;
  }
  .presentation-page .section-content .image-container {
    height: 550px;
  }
  .index-page .category-absolute {
    top: 90vh;
  }
  .footer ul {
    text-align: left;
  }
}

@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
  .section-images .hero-images-container,
  .section-images .hero-images-container-1,
  .section-images .hero-images-container-2 {
    margin-top: -15vh;
    margin-left: 80px;
  }
  .section-images .hero-images-container {
    max-width: 300px;
  }
  .section-images .hero-images-container-1 {
    right: 28%;
    top: 40%;
  }
  .section-images .hero-images-container-2 {
    right: 21%;
    top: 55%;
  }
  .index-page .category-absolute {
    top: 90vh;
  }
}

@media (max-width: 768px) {
  .btn,
  .btn-morphing {
    margin-bottom: 10px;
  }
  .parallax .motto {
    top: 170px;
    margin-top: 0;
    font-size: 60px;
    width: 270px;
  }
}

@media screen and (max-width: 767px) {
  .presentation-page .section-icons .icons-nucleo {
    top: -135px;
  }
  .presentation-page .section-icons .icons-nucleo.icons-nucleo-right {
    top: 0;
  }
  .presentation-page .first-right-icon,
  .presentation-page .second-right-icon,
  .presentation-page .third-right-icon,
  .presentation-page .fourth-right-icon,
  .presentation-page .fifth-right-icon,
  .presentation-page .sixth-right-icon,
  .presentation-page .seventh-right-icon,
  .presentation-page .eighth-right-icon,
  .presentation-page .ninth-right-icon,
  .presentation-page .tenth-right-icon,
  .presentation-page .second-left-icon,
  .presentation-page .third-left-icon,
  .presentation-page .fifth-left-icon,
  .presentation-page .sixth-left-icon,
  .presentation-page .eighth-left-icon {
    display: none;
  }
  .presentation-page .section-icons .icons-nucleo .first-left-icon {
    left: 2%;
  }
  .presentation-page .section-icons .icons-nucleo .fourth-left-icon {
    left: 46%;
  }
  .presentation-page .section-icons .icons-nucleo .seventh-left-icon {
    left: 80%;
    font-size: 55px;
  }
  .presentation-page .section-icons .icons-nucleo .ninth-left-icon {
    left: 28%;
  }
  .presentation-page .section-icons .icons-nucleo .tenth-left-icon {
    left: 65%;
  }
  .presentation-page .testimonials-people img {
    position: relative;
    display: none;
  }
  .presentation-page .section-content .image-container {
    margin-bottom: 45px;
  }
  .presentation-page .section-content img {
    margin-bottom: 15px;
  }
}

@media screen and (min-width: 768px) {
  .presentation-page .section-sections .row {
    margin-left: -30px;
    margin-right: -30px;
  }
  .presentation-page .section-sections .rellax {
    left: 60px;
    position: absolute !important;
    z-index: 4 !important;
    box-shadow: 0px 8px 50px 0px rgba(0, 0, 0, 0.4);
  }
}

@media screen and (max-width: 576px) {
  #images img {
    max-width: 50%;
    margin-bottom: 15px;
  }
}

/*       Loading dots  */

#images h4 {
  margin-bottom: 30px;
}

#javascriptComponents {
  padding-bottom: 0;
}

/*      layer animation          */

.layers-container {
  display: block;
  margin-top: 50px;
  position: relative;
}

.layers-container img {
  position: absolute;
  width: 100%;
  height: auto;
  top: 0;
  left: 0;
  text-align: center;
}

.animate {
  transition: 1.5s ease-in-out;
  -moz-transition: 1.5s ease-in-out;
  -webkit-transition: 1.5s ease-in-out;
}

.navbar-default.navbar-small .logo-container .brand {
  color: #333333;
}

.navbar-transparent.navbar-small .logo-container .brand {
  color: #FFFFFF;
}

.navbar-default.navbar-small .logo-container .brand {
  color: #333333;
}

.sharing-area {
  margin-top: 80px;
}

.sharing-area .btn {
  margin: 15px 4px 0;
}

.section-thin,
.section-notifications {
  padding: 0;
}

.section-navbars {
  padding-top: 0;
}

#navbar .navbar {
  margin-bottom: 20px;
}

#navbar .navbar-toggler,
#menu-dropdown .navbar-toggler {
  pointer-events: none;
}

.section-tabs {
  background: #ebebeb;
}

.section-pagination {
  padding-bottom: 0;
}

.section-download {
  padding-top: 130px;
}

.section-download .description {
  margin-bottom: 60px;
}

.section-download h4 {
  margin-bottom: 25px;
}

.section-examples a {
  text-decoration: none;
}

.section-examples a+a {
  margin-top: 30px;
}

.section-examples h5 {
  margin-top: 30px;
}

.components-page .wrapper>.header,
.tutorial-page .wrapper>.header {
  height: 500px;
  padding-top: 128px;
  background-size: cover;
  background-position: center center;
}

.components-page .title,
.tutorial-page .title {
  color: #FFFFFF;
}

.invision-logo {
  max-width: 70px;
  top: -2px;
  position: relative;
}

.creative-tim-logo {
  max-width: 140px;
  top: -2px;
  position: relative;
}

.section-javascript .title {
  margin-bottom: 0;
}

.navbar .switch-background {
  display: block;
}

.navbar-transparent .switch-background {
  display: none;
}

.section-signup .col .btn {
  margin-top: 30px;
}

#buttons-row .btn {
  margin-bottom: 10px;
}

@media screen and (max-width: 991px) {
  .section-navbars .navbar-collapse,
  .header-1 .navbar-collapse,
  .header-2 .navbar-collapse,
  .header-3 .navbar-collapse {
    display: none !important;
  }
  .presentation-page .section-basic-components .image-container {
    height: 425px;
    margin-top: 100px;
  }
  .presentation-page .section-basic-components .image-container .components-macbook {
    width: 100%;
    height: 100%;
    position: relative;
    left: 0;
  }
  .presentation-page .section-free-demo .github-background-container {
    position: initial;
    left: 0;
    top: 0;
    max-width: 400px;
    margin: 0 auto;
    text-align: center;
  }
  .presentation-page .section-free-demo .github-background-container i {
    font-size: 400px;
  }
  .presentation-page .section-components .col-md-3 {
    padding-left: 15px;
  }
  .presentation-page .h3-description,
  .presentation-page .index-page .h3-description {
    top: 53%;
  }
}

@media (max-width: 1200px) and (min-width: 991px) {
  .presentation-page .section-basic-components .image-container {
    height: 326px;
    margin-top: 30px;
  }
  .presentation-page .section-basic-components .image-container .social-img {
    height: 48px;
  }
  .presentation-page .rellax-text-container,
  .index-page .rellax-text-container {
    max-width: 900px;
    top: 27%;
  }
  .index-page .rellax-text-container {
    top: 23%;
  }
  .presentation-page .rellax-text-container .pro {
    font-size: 18px;
    top: 29px;
    right: -29px;
  }
  .presentation-page .rellax-text-container .h1-seo {
    font-size: 14em;
  }
  .index-page .rellax-text-container .h1-seo {
    font-size: 9em;
  }
}

.burger-menu .section-navbars .navbar-collapse {
  display: none !important;
}

.section-basic {
  padding-top: 0;
}

.section-images {
  padding-bottom: 0;
  z-index: 2;
}

.table-img,
.coloured-card-img,
.coloured-card-btn-img,
.linkedin-btn-img,
.share-btn-img,
.social-img {
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-timing-function: ease-in-out;
  -moz-animation-iteration-count: infinite;
  -moz-animation-timing-function: ease-in-out;
  -webkit-animation-name: Floatingy;
  -moz-animation-name: Floatingy;
  float: left;
}

.table-img {
  -webkit-animation-duration: 14s;
  -moz-animation-duration: 14s;
  -webkit-animation-name: Floatingx;
  -moz-animation-name: Floatingx;
}

.coloured-card-img {
  -webkit-animation-duration: 10s;
  -moz-animation-duration: 10s;
}

.coloured-card-btn-img {
  -webkit-animation-duration: 18s;
  -moz-animation-duration: 18s;
}

.linkedin-btn-img {
  -webkit-animation-duration: 15s;
  -moz-animation-duration: 15s;
  -webkit-animation-name: Floatingx;
  -moz-animation-name: Floatingx;
}

.share-btn-img {
  -webkit-animation-duration: 11s;
  -moz-animation-duration: 11s;
}

.social-img {
  -webkit-animation-duration: 16s;
  -moz-animation-duration: 16s;
  -webkit-animation-name: Floatingx;
  -moz-animation-name: Floatingx;
}

.bd-example .btn {
  margin: 5px 0;
}

.offline-doc .page-header {
  display: flex;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/assets/demo/demo.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA,qBAAqB;;AAErB;;;;;EAQE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,mBAAmB;IACnB,kBAAkB;EACpB;AACF;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,cAAc;EACd,oBAAoB;EACpB,4BAA4B;EAC5B,eAAe;EACf,SAAS;EACT,QAAQ;EACR,aAAa;EACb,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,wEAAwE;AAC1E;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,sCAAsC;EACtC,8CAA8C;EAK9C,qDAAqD;AACvD;;AAEA;EACE,SAAS;EACT,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,QAAQ;EACR,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,QAAQ;EACR,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,QAAQ;EACR,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,QAAQ;EACR,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,QAAQ;EACR,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,QAAQ;EACR,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,QAAQ;EACR,UAAU;EACV,eAAe;AACjB;;AAEA;;;;;EAKE,qBAAqB;EACrB,kBAAkB;EAClB,+CAA+C;EAC/C,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,UAAU;EACV,UAAU;EACV,UAAU;AACZ;;AAEA;;EAEE,UAAU;EACV,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EAGE,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EAIE,4BAA4B;EAC5B,kBAAkB;EAClB,aAAa;AACf;;AAEA;EAIE,2BAA2B;EAI3B,0BAA0B;EAC1B,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,6CAA6C;EAC7C,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,MAAM;EACN,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;;;;;EAME,kBAAkB;EAClB,qHAAqH;AACvH;;AAEA;EACE,SAAS;EACT,QAAQ;EACR,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,SAAS;EACT,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,QAAQ;EACR,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,QAAQ;EACR,QAAQ;EACR,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;AACV;;AAEA;;EAEE,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;EAChB,8CAA8C;EAC9C,UAAU;EACV,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EAGnB,iEAAiE;EACjE,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;;EAEE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;AAEA;;EAEE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,sBAAsB;EACtB,wBAAwB;EACxB,UAAU;EACV,4BAA4B;AAC9B;;AAEA;;EAEE,UAAU;EACV,QAAQ;EACR,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;;EAEE,UAAU;EACV,WAAW;AACb;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,OAAO;EACP,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kCAAkC;EAClC,sBAAsB;EACtB,aAAa;EACb,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,cAAc;EACd,4BAA4B;EAC5B,4BAA4B;EAC5B,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,WAAW;IACX,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,YAAY;IACZ,WAAW;EACb;AACF;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,cAAc;EAChB;EACA;IACE,iBAAiB;IACjB,aAAa;EACf;EACA;IACE,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,cAAc;EAChB;EACA;IAIE,wBAAwB;EAC1B;EACA;;IAIE,iEAAiE;IACjE,6BAA6B;IAC7B,gBAAgB;EAClB;EACA;;IAEE,QAAQ;IACR,gBAAgB;EAClB;EACA;IACE,QAAQ;EACV;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;;IAEE,gBAAgB;IAChB,QAAQ;EACV;EACA;IACE,QAAQ;EACV;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,UAAU;IACV,UAAU;EACZ;AACF;;AAEA;EACE;;IAEE,gBAAgB;IAChB,QAAQ;EACV;EACA;IACE,QAAQ;EACV;EACA;IACE,eAAe;IACf,SAAS;IACT,WAAW;EACb;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,UAAU;IACV,WAAW;IACX,SAAS;EACX;EACA;IACE,UAAU;IACV,YAAY;IACZ,UAAU;EACZ;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,oBAAoB;EACtB;EACA;;IAEE,UAAU;IACV,UAAU;EACZ;EACA;;IAEE,UAAU;IACV,UAAU;EACZ;EACA;IACE,UAAU;IACV,UAAU;EACZ;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;;;;;;;;;;;;;;;;IAgBE,aAAa;EACf;EACA;;IAEE,SAAS;EACX;EACA;IACE,QAAQ;IACR,UAAU;EACZ;EACA;IACE,aAAa;EACf;EACA;IACE,SAAS;EACX;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;;;IAGE,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,UAAU;IACV,QAAQ;EACV;EACA;IACE,UAAU;IACV,QAAQ;EACV;EACA;IACE,SAAS;EACX;AACF;;AAEA;EACE;;IAEE,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,aAAa;IACb,eAAe;IACf,YAAY;EACd;AACF;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,MAAM;EACR;EACA;;;;;;;;;;;;;;;IAeE,aAAa;EACf;EACA;IACE,QAAQ;EACV;EACA;IACE,SAAS;EACX;EACA;IACE,SAAS;IACT,eAAe;EACjB;EACA;IACE,SAAS;EACX;EACA;IACE,SAAS;EACX;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,6BAA6B;IAC7B,qBAAqB;IACrB,+CAA+C;EACjD;AACF;;AAEA;EACE;IACE,cAAc;IACd,mBAAmB;EACrB;AACF;;AAEA,wBAAwB;;AAExB;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,kCAAkC;;AAElC;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;;;;IAIE,wBAAwB;EAC1B;EACA;IACE,aAAa;IACb,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,OAAO;EACT;EACA;IACE,iBAAiB;IACjB,OAAO;IACP,MAAM;IACN,gBAAgB;IAChB,cAAc;IACd,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;;IAEE,QAAQ;EACV;AACF;;AAEA;EACE;IACE,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,YAAY;EACd;EACA;;IAEE,gBAAgB;IAChB,QAAQ;EACV;EACA;IACE,QAAQ;EACV;EACA;IACE,eAAe;IACf,SAAS;IACT,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;AACF;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,UAAU;AACZ;;AAkDA;;;;;;EAME,2CAA2C;EAC3C,8CAA8C;EAC9C,wCAAwC;EACxC,2CAA2C;EAC3C,iCAAiC;EACjC,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,iCAAiC;EACjC,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,iCAAiC;EACjC,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,iCAAiC;EACjC,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB","sourcesContent":[".tim-row {\n  margin-bottom: 20px;\n}\n\n/*      transitions */\n\n.presentation-page .front,\n.presentation-page .front:after,\n.presentation-page .front .btn,\n.logo-container .logo,\n.logo-container .brand {\n  -webkit-transition: all .2s;\n  -moz-transition: all .2s;\n  -o-transition: all .2s;\n  transition: all .2s;\n}\n\n.bd-docs .navbar .navbar-nav {\n  margin-top: 0;\n}\n\n.section-notifications .container-fluid {\n  padding: 0;\n}\n\n@media screen and (max-width: 576px) {\n  .section-notifications .container-fluid {\n    padding-right: 15px;\n    padding-left: 15px;\n  }\n}\n\n.presentation-page {\n  /*       Loading dots  */\n}\n\n.presentation-page .loader {\n  opacity: 0;\n  display: block;\n  transition: all 0.4s;\n  -webkit-transition: all 0.4s;\n  position: fixed;\n  left: 50%;\n  top: 50%;\n  z-index: 1031;\n  margin-left: -32px;\n  margin-top: -32px;\n}\n\n.presentation-page .section-basic-components,\n.presentation-page .section-testimonials {\n  overflow: hidden;\n}\n\n.presentation-page .loader.visible {\n  display: block;\n  opacity: 1;\n}\n\n.presentation-page .modal-content {\n  background-color: transparent;\n  box-shadow: 0 0 0;\n}\n\n.presentation-page .modal-backdrop.in {\n  opacity: 0.45;\n}\n\n.presentation-page .preload-image {\n  display: none;\n  box-shadow: 0 0 15px rgba(0, 0, 0, 0.15), 0 0 1px 1px rgba(0, 0, 0, 0.1);\n}\n\n.presentation-page .section-components .col-md-3 {\n  max-width: 16%;\n  padding-left: 100px;\n}\n\n.presentation-page .section-icons {\n  padding: 180px 0;\n}\n\n.presentation-page .section-icons [class*=\"col-\"]:nth-child(2) {\n  padding: 0 70px;\n}\n\n.presentation-page .section-icons[data-background-color=\"black\"] {\n  background-color: #777777;\n}\n\n.presentation-page .section-icons .icons-nucleo {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  top: -48px;\n}\n\n.presentation-page .section-icons .icons-nucleo .now-ui-icons {\n  position: absolute;\n  color: #fff;\n  transform: translate3D(0px, 50px, 0px);\n  -webkit-transform: translate3D(0px, 50px, 0px);\n  -webkit-transition: all 0.6s cubic-bezier(0.34, 2, 0.7, 1) 0s;\n  -moz-transition: all 0.6s cubic-bezier(0.34, 2, 0.7, 1) 0s;\n  -o-transition: all 0.6s cubic-bezier(0.34, 2, 0.7, 1) 0s;\n  -ms-transition: all 0.6s cubic-bezier(0.34, 2, 0.7, 1) 0s;\n  transition: all 0.6s cubic-bezier(0.34, 2, 0.7, 1) 0s;\n}\n\n.presentation-page .section-icons .icons-nucleo .first-left-icon {\n  top: -25%;\n  left: 10%;\n  font-size: 65px;\n}\n\n.presentation-page .section-icons .icons-nucleo .second-left-icon {\n  top: 0%;\n  left: 45%;\n  font-size: 35px;\n}\n\n.presentation-page .section-icons .icons-nucleo .third-left-icon {\n  top: 30%;\n  left: 65%;\n  font-size: 25px;\n}\n\n.presentation-page .section-icons .icons-nucleo .fourth-left-icon {\n  top: 70%;\n  left: 10%;\n  font-size: 50px;\n}\n\n.presentation-page .section-icons .icons-nucleo .fifth-left-icon {\n  top: 45%;\n  left: 30%;\n  font-size: 40px;\n}\n\n.presentation-page .section-icons .icons-nucleo .sixth-left-icon {\n  top: 120%;\n  left: 35%;\n  font-size: 40px;\n}\n\n.presentation-page .section-icons .icons-nucleo .seventh-left-icon {\n  top: 35%;\n  left: 85%;\n  font-size: 45px;\n}\n\n.presentation-page .section-icons .icons-nucleo .eighth-left-icon {\n  top: 90%;\n  left: 55%;\n  font-size: 30px;\n}\n\n.presentation-page .section-icons .icons-nucleo .ninth-left-icon {\n  top: 40%;\n  left: 5%;\n  font-size: 40px;\n}\n\n.presentation-page .section-icons .icons-nucleo .tenth-left-icon {\n  top: 75%;\n  left: 80%;\n  font-size: 35px;\n}\n\n.presentation-page .section-icons .icons-nucleo .first-right-icon {\n  top: -25%;\n  right: 10%;\n  font-size: 65px;\n}\n\n.presentation-page .section-icons .icons-nucleo .second-right-icon {\n  top: 0%;\n  right: 45%;\n  font-size: 35px;\n}\n\n.presentation-page .section-icons .icons-nucleo .third-right-icon {\n  top: 30%;\n  right: 65%;\n  font-size: 25px;\n}\n\n.presentation-page .section-icons .icons-nucleo .fourth-right-icon {\n  top: 70%;\n  right: 10%;\n  font-size: 50px;\n}\n\n.presentation-page .section-icons .icons-nucleo .fifth-right-icon {\n  top: 45%;\n  right: 30%;\n  font-size: 40px;\n}\n\n.presentation-page .section-icons .icons-nucleo .sixth-right-icon {\n  top: 120%;\n  right: 35%;\n  font-size: 35px;\n}\n\n.presentation-page .section-icons .icons-nucleo .seventh-right-icon {\n  top: 35%;\n  right: 88%;\n  font-size: 30px;\n}\n\n.presentation-page .section-icons .icons-nucleo .eighth-right-icon {\n  top: 90%;\n  right: 55%;\n  font-size: 35px;\n}\n\n.presentation-page .section-icons .icons-nucleo .ninth-right-icon {\n  top: 40%;\n  right: 5%;\n  font-size: 40px;\n}\n\n.presentation-page .section-icons .icons-nucleo .tenth-right-icon {\n  top: 75%;\n  right: 80%;\n  font-size: 35px;\n}\n\n.presentation-page .section-cards .image-container1,\n.presentation-page .section-cards .image-container2,\n.presentation-page .section-cards .image-container3,\n.presentation-page .section-cards .image-container4,\n.presentation-page .section-cards .image-container5 {\n  display: inline-block;\n  position: relative;\n  box-shadow: 0px 5px 25px 0px rgba(0, 0, 0, 0.2);\n  border-radius: 0.1875rem;\n  overflow: hidden;\n}\n\n.presentation-page .section-cards .image-container1 {\n  left: 48px;\n}\n\n.presentation-page .section-cards .image-container5 {\n  right: 48px;\n}\n\n.presentation-page .section-cards .image-container2 {\n  left: 25px;\n}\n\n.presentation-page .section-cards .image-container4 {\n  right: 25px;\n}\n\n.presentation-page .section-cards .images-container {\n  height: 100%;\n  margin: 0 auto;\n  text-align: center;\n  margin-top: 60px;\n}\n\n.presentation-page .section-cards .image-container1,\n.presentation-page .section-cards .image-container5 {\n  width: 16%;\n  top: -53px;\n  z-index: 1;\n}\n\n.presentation-page .section-cards .image-container2,\n.presentation-page .section-cards .image-container4 {\n  width: 22%;\n  top: -27px;\n  z-index: 2;\n}\n\n.presentation-page .section-cards .image-container3 {\n  width: 22%;\n  z-index: 3;\n}\n\n.presentation-page .section-cards+.section-content {\n  padding-top: 480px;\n  padding-bottom: 30px;\n  margin-top: -277px;\n}\n\n.presentation-page .page-header+.section-components {\n  padding-top: 300px;\n}\n\n.presentation-page .colors {\n  padding: 100px 0;\n}\n\n.presentation-page>.description {\n  padding-top: 20px;\n}\n\n.presentation-page .section-rotation {\n  padding: 140px 0;\n}\n\n.presentation-page .section-images {\n  padding: 80px 0;\n}\n\n.presentation-page .section-thin {\n  padding: 0;\n}\n\n.presentation-page .section-pay {\n  padding-top: 20px;\n}\n\n.presentation-page .colors {\n  padding: 70px 0;\n  z-index: 7;\n  position: relative;\n  margin-top: -300px;\n}\n\n.presentation-page .colors {\n  border-top: 1px solid #DDDDDD;\n}\n\n.presentation-page .card-container {\n  -webkit-perspective: 900px;\n  -moz-perspective: 900px;\n  -o-perspective: 900px;\n  perspective: 900px;\n  width: 300px;\n  position: relative;\n  margin-top: 90px;\n}\n\n.presentation-page .card-component {\n  -webkit-transform-style: preserve-3d;\n  -moz-transform-style: preserve-3d;\n  -o-transform-style: preserve-3d;\n  transform-style: preserve-3d;\n  position: relative;\n  height: 500px;\n}\n\n.presentation-page .card-component .front {\n  -webkit-backface-visibility: hidden;\n  -moz-backface-visibility: hidden;\n  -o-backface-visibility: hidden;\n  backface-visibility: hidden;\n  -webkit-transform: rotateY(-35deg);\n  -moz-transform: rotateY(-35deg);\n  -o-transform: rotateY(-35deg);\n  transform: rotateY(-35deg);\n  position: absolute;\n  top: 0;\n  left: 0;\n  background-color: #FFF;\n  width: 100%;\n  cursor: pointer;\n  box-shadow: 10px 4px 14px rgba(0, 0, 0, 0.12);\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.presentation-page h5.description {\n  margin-top: 35px;\n}\n\n.presentation-page .category {\n  text-transform: uppercase;\n}\n\n.presentation-page .section-basic-components {\n  padding: 190px 0;\n}\n\n.presentation-page .section-basic-components .title {\n  margin-top: 60px;\n}\n\n.presentation-page .section-basic-components .image-container {\n  height: 380px;\n  position: relative;\n}\n\n.presentation-page .section-basic-components .image-container .components-macbook {\n  width: auto;\n  left: 100px;\n  top: 0;\n  height: auto;\n  position: absolute;\n}\n\n.presentation-page .section-basic-components .image-container .table-img,\n.presentation-page .section-basic-components .image-container .share-btn-img,\n.presentation-page .section-basic-components .image-container .coloured-card-btn-img,\n.presentation-page .section-basic-components .image-container .coloured-card-img,\n.presentation-page .section-basic-components .image-container .social-img,\n.presentation-page .section-basic-components .image-container .linkedin-btn-img {\n  position: absolute;\n  box-shadow: 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12), 0 5px 5px -3px rgba(0, 0, 0, 0.2);\n}\n\n.presentation-page .section-basic-components .image-container .table-img {\n  left: 65%;\n  top: 23%;\n  height: 175px;\n  border-radius: 3px;\n}\n\n.presentation-page .section-basic-components .image-container .share-btn-img {\n  left: 83%;\n  top: 95%;\n  height: 25px;\n  border-radius: 10px;\n}\n\n.presentation-page .section-basic-components .image-container .coloured-card-img {\n  left: 50%;\n  top: -11%;\n  height: 102px;\n  border-radius: 3px;\n}\n\n.presentation-page .section-basic-components .image-container .coloured-card-btn-img {\n  left: -3%;\n  top: 42%;\n  height: 133px;\n  border-radius: 3px;\n}\n\n.presentation-page .section-basic-components .image-container .social-img {\n  left: -4%;\n  top: 95%;\n  height: 57px;\n}\n\n.presentation-page .section-basic-components .image-container .linkedin-btn-img {\n  left: 3%;\n  top: -3%;\n  height: 25px;\n  border-radius: 10px;\n}\n\n.presentation-page .section-components+.section {\n  margin-top: -270px;\n  z-index: 7;\n  position: relative;\n  border-top: 1px solid rgba(231, 231, 231, 0.5);\n}\n\n.presentation-page .info {\n  max-width: 410px;\n}\n\n.presentation-page .section-free-demo {\n  overflow: hidden;\n}\n\n.presentation-page .section-free-demo .github-buttons>.btn {\n  float: left;\n  margin-right: 15px;\n}\n\n.presentation-page .section-free-demo .github-buttons .github-button {\n  float: left;\n  margin-top: 15px;\n}\n\n.presentation-page .section-free-demo .github-background-container {\n  position: absolute;\n  right: -420px;\n  top: -50px;\n}\n\n.presentation-page .section-free-demo .github-background-container i {\n  font-size: 810px;\n  opacity: .1;\n}\n\n.presentation-page .section-sections {\n  overflow: hidden;\n  padding-top: 200px;\n}\n\n.presentation-page .section-sections .container-fluid {\n  z-index: 1;\n}\n\n.presentation-page .section-sections .container-fluid img {\n  position: relative;\n  z-index: 2;\n}\n\n.presentation-page .section-examples {\n  margin-top: -125px;\n}\n\n.presentation-page .section-examples .section-description {\n  margin-top: 100px;\n}\n\n.presentation-page .section-testimonials {\n  padding-bottom: 0;\n}\n\n.presentation-page .section-testimonials[data-background-color=\"black\"] {\n  background: #181818;\n}\n\n.presentation-page .section-testimonials .carousel .card {\n  margin: 40px auto;\n}\n\n.presentation-page .section-testimonials .testimonials-people {\n  margin-top: -100px;\n}\n\n.presentation-page .section-pricing .our-clients {\n  margin-bottom: 100px;\n  margin-top: 50px;\n}\n\n.presentation-page .section-pricing .our-clients img {\n  width: 100%;\n  max-width: 120px;\n  margin: 0 30px;\n  display: inline-block;\n}\n\n.presentation-page .section-sharing span {\n  margin-top: 30px;\n  display: block;\n}\n\n.presentation-page .section-sharing .fa-pay {\n  font-size: 30px;\n  display: inline-block;\n  margin: 5px 1px 0;\n  width: auto;\n}\n\n.presentation-page .section-components {\n  z-index: 1;\n}\n\n.presentation-page .front img {\n  z-index: 2;\n  position: relative;\n}\n\n.presentation-page .card-component img {\n  width: 100%;\n}\n\n.presentation-page .description .col-md-3 {\n  width: 16%;\n  margin-left: 4%;\n}\n\n.presentation-page .first-card {\n  z-index: 6;\n}\n\n.presentation-page .second-card {\n  z-index: 5;\n}\n\n.presentation-page .third-card {\n  z-index: 4;\n}\n\n.presentation-page .fourth-card {\n  z-index: 3;\n}\n\n.presentation-page .section-gray h1 small {\n  color: #888888;\n}\n\n.presentation-page .color-container {\n  text-align: center;\n}\n\n.presentation-page .color-container img {\n  width: 100%;\n  margin-bottom: 10px;\n}\n\n.presentation-page .circle-color {\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  display: block;\n  background-color: #cccccc;\n  margin: 0 auto;\n}\n\n.presentation-page .circle-red {\n  background-color: #ff3b30;\n}\n\n.presentation-page .circle-blue {\n  background-color: #3472f7;\n}\n\n.presentation-page .circle-azure {\n  background-color: #2ca8ff;\n}\n\n.presentation-page .circle-green {\n  background-color: #05ae0e;\n}\n\n.presentation-page .circle-orange {\n  background-color: #ff9500;\n}\n\n.presentation-page .rellax-text-container,\n.index-page .rellax-text-container {\n  max-width: 1003px;\n  margin: 0 auto;\n  text-align: center;\n  position: relative;\n  top: 24%;\n}\n\n.presentation-page .rellax-text-container .h1-seo,\n.index-page .rellax-text-container .h1-seo {\n  font-size: 16.8em;\n  text-transform: uppercase;\n  font-weight: 700;\n  font-family: 'Open Sans Condensed', sans-serif;\n  z-index: 1;\n  letter-spacing: -10px;\n  text-align: center;\n  background: #ffedea;\n  background: -moz-linear-gradient(top, #FFFFFF 35%, #c38775 100%);\n  background: -webkit-linear-gradient(top, #FFFFFF 35%, #c38775 100%);\n  background: linear-gradient(to bottom, #FFFFFF 35%, #c38775 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.presentation-page .rellax-text-container .pro,\n.index-page .rellax-text-container .pro {\n  position: absolute;\n  font-size: 20px;\n  background: #132026;\n  padding: 6px 10px;\n  border-radius: 4px;\n  top: 41px;\n  font-weight: 600;\n  margin-top: 10px;\n  right: -78px;\n}\n\n.presentation-page .n-logo,\n.index-page .n-logo {\n  max-width: 100px;\n  margin-bottom: 40px;\n}\n\n.presentation-page .page-header-city,\n.index-page .page-header-city {\n  background-size: cover;\n  background-position: top;\n  top: 25.5%;\n  background-repeat: no-repeat;\n}\n\n.presentation-page .h3-description,\n.index-page .h3-description {\n  z-index: 3;\n  top: 50%;\n  position: absolute;\n  width: 100%;\n  text-align: center;\n  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.71);\n}\n\n.presentation-page .category-absolute,\n.index-page .category-absolute {\n  z-index: 3;\n}\n\n.presentation-page .rellax-header,\n.index-page .rellax-header {\n  position: absolute;\n  height: 100%;\n  width: 100%;\n}\n\n.presentation-page .rellax-header-sky,\n.index-page .rellax-header-sky {\n  z-index: 0;\n  height: 50%;\n}\n\n.presentation-page .rellax-header-buildings,\n.index-page .rellax-header-buildings {\n  z-index: 2;\n}\n\n.presentation-page [data-background-color=\"dark-red\"],\n.index-page [data-background-color=\"dark-red\"] {\n  background: #220c08;\n}\n\n.presentation-page .page-header,\n.index-page .page-header {\n  background: #d0aea8;\n}\n\n.index-page .rellax-text-container {\n  top: 22%;\n}\n\n.index-page .rellax-text-container .h1-seo {\n  letter-spacing: -3px;\n  font-size: 10.3em;\n}\n\n.tim-white-buttons {\n  background-color: #777777;\n}\n\n.typography-line {\n  padding-left: 25%;\n  margin-bottom: 35px;\n  position: relative;\n  display: block;\n  width: 100%;\n}\n\n.typography-line span {\n  bottom: 10px;\n  color: #c0c1c2;\n  display: block;\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 13px;\n  left: 0;\n  margin-left: 20px;\n  position: absolute;\n  width: 260px;\n  text-transform: none;\n}\n\n.tim-row {\n  padding-top: 60px;\n}\n\n.tim-row h3 {\n  margin-top: 0;\n}\n\n.switch {\n  margin-right: 20px;\n}\n\n#navbar-full .navbar {\n  border-radius: 0 !important;\n  margin-bottom: 15px;\n  z-index: 2;\n}\n\n#menu-dropdown .navbar {\n  border-radius: 3px;\n}\n\n#pagination-row .pagination-container {\n  height: 100%;\n  max-height: 100%;\n  display: flex;\n  align-items: center;\n}\n\n#icons-row i.now-ui-icons {\n  font-size: 30px;\n}\n\n.space {\n  height: 130px;\n  display: block;\n}\n\n.space-110 {\n  height: 110px;\n  display: block;\n}\n\n.space-50 {\n  height: 50px;\n  display: block;\n}\n\n.space-70 {\n  height: 70px;\n  display: block;\n}\n\n.navigation-example .img-src {\n  background-attachment: scroll;\n}\n\n.navigation-example {\n  background-position: center center;\n  background-size: cover;\n  margin-top: 0;\n  min-height: 740px;\n  height: 100%;\n}\n\n#notifications {\n  background-color: #FFFFFF;\n  display: block;\n  width: 100%;\n  position: relative;\n}\n\n.tim-note {\n  text-transform: capitalize;\n}\n\n#buttons .btn,\n#javascriptComponents .btn {\n  margin: 0 0px 10px;\n}\n\n.space-100 {\n  height: 100px;\n  display: block;\n  width: 100%;\n}\n\n.be-social {\n  padding-bottom: 20px;\n  /*     border-bottom: 1px solid #aaa; */\n  margin: 0 auto 40px;\n}\n\n.txt-white {\n  color: #FFFFFF;\n}\n\n.txt-gray {\n  color: #ddd !important;\n}\n\n.parallax {\n  width: 100%;\n  height: 570px;\n  display: block;\n  background-attachment: fixed;\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center center;\n}\n\n.logo-container .logo {\n  overflow: hidden;\n  border-radius: 50%;\n  border: 1px solid #333333;\n  width: 50px;\n  float: left;\n}\n\n.logo-container .brand {\n  font-size: 16px;\n  color: #FFFFFF;\n  line-height: 18px;\n  float: left;\n  margin-left: 10px;\n  margin-top: 7px;\n  width: 70px;\n  height: 40px;\n  text-align: left;\n}\n\n.logo-container .brand-material {\n  font-size: 18px;\n  margin-top: 15px;\n  height: 25px;\n  width: auto;\n}\n\n.logo-container .logo img {\n  width: 100%;\n}\n\n.navbar-small .logo-container .brand {\n  color: #333333;\n}\n\n.fixed-section {\n  top: 90px;\n  max-height: 80vh;\n  overflow: scroll;\n  position: sticky;\n}\n\n.fixed-section ul {\n  padding: 0;\n}\n\n.fixed-section ul li {\n  list-style: none;\n}\n\n.fixed-section li a {\n  font-size: 14px;\n  padding: 2px;\n  display: block;\n  color: #666666;\n}\n\n.fixed-section li a.active {\n  color: #00bbff;\n}\n\n.fixed-section.float {\n  position: fixed;\n  top: 100px;\n  width: 200px;\n  margin-top: 0;\n}\n\n.parallax .parallax-image {\n  width: 100%;\n  overflow: hidden;\n  position: absolute;\n}\n\n.parallax .parallax-image img {\n  width: 100%;\n}\n\n@media (max-width: 768px) {\n  .parallax .parallax-image {\n    width: 100%;\n    height: 640px;\n    overflow: hidden;\n  }\n  .parallax .parallax-image img {\n    height: 100%;\n    width: auto;\n  }\n}\n\n.social-buttons-demo .btn {\n  margin-right: 5px;\n  margin-bottom: 7px;\n}\n\n.img-container {\n  width: 100%;\n  overflow: hidden;\n}\n\n.img-container img {\n  width: 100%;\n}\n\n.lightbox img {\n  width: 100%;\n}\n\n.lightbox .modal-content {\n  overflow: hidden;\n}\n\n.lightbox .modal-body {\n  padding: 0;\n}\n\n@media screen and (min-width: 991px) {\n  .lightbox .modal-dialog {\n    width: 960px;\n  }\n}\n\n@media screen and (max-width: 576px) {\n  .index-page .typography-line span {\n    margin-left: 0;\n  }\n  .presentation-page .section-cards+.section-content {\n    padding-top: 70px;\n    margin-top: 0;\n  }\n  .presentation-page .rellax-text-container .pro {\n    bottom: 84px;\n    top: initial;\n    font-size: 13px;\n    right: 55px;\n  }\n  .presentation-page .section-components .col-md-3 {\n    max-width: inherit;\n  }\n  .presentation-page .card-container {\n    margin: 0 auto;\n  }\n  .presentation-page .card-container .card-component .front {\n    -webkit-transform: rotateY(0deg);\n    -moz-transform: rotateY(0deg);\n    -o-transform: rotateY(0deg);\n    transform: rotateY(0deg);\n  }\n  .presentation-page .rellax-text-container .h1-seo,\n  .presentation-page .index-page .h1-seo {\n    background: -moz-linear-gradient(top, #FFFFFF 64%, #c38775 100%);\n    background: -webkit-linear-gradient(top, #FFFFFF 64%, #c38775 100%);\n    background: linear-gradient(to bottom, #FFFFFF 64%, #c38775 100%);\n    -webkit-background-clip: text;\n    font-size: 8.4em;\n  }\n  .presentation-page .rellax-text-container,\n  .index-page .rellax-text-container {\n    top: 21%;\n    max-width: 360px;\n  }\n  .index-page .rellax-text-container {\n    top: 25%;\n  }\n  .index-page .rellax-text-container .h1-seo {\n    font-size: 3.8em;\n  }\n}\n\n@media only screen and (min-device-width: 375px) and (max-device-width: 667px) {\n  .presentation-page .rellax-text-container {\n    top: 20% !important;\n  }\n  .presentation-page .page-header+.section-components {\n    padding-top: 200px;\n  }\n}\n\n@media only screen and (min-device-width: 375px) and (max-device-width: 667px) and (orientation: portrait) {\n  .presentation-page .rellax-text-container {\n    top: 17% !important;\n  }\n}\n\n@media screen and (max-width: 768px) and (min-width: 576px) {\n  .presentation-page .rellax-text-container,\n  .index-page .rellax-text-container {\n    max-width: 565px;\n    top: 33%;\n  }\n  .index-page .rellax-text-container {\n    top: 26%;\n  }\n  .presentation-page .rellax-text-container .h1-seo {\n    font-size: 9.3em;\n  }\n  .index-page .rellax-text-container .h1-seo {\n    font-size: 5.6em;\n  }\n  .presentation-page .rellax-text-container .pro {\n    font-size: 12px;\n    top: -14px;\n    right: 2px;\n  }\n}\n\n@media screen and (max-width: 991px) and (min-width: 768px) {\n  .presentation-page .rellax-text-container,\n  .index-page .rellax-text-container {\n    max-width: 730px;\n    top: 32%;\n  }\n  .index-page .rellax-text-container {\n    top: 24%;\n  }\n  .presentation-page .rellax-text-container .pro {\n    font-size: 14px;\n    top: 18px;\n    right: -3px;\n  }\n  .presentation-page .rellax-text-container .h1-seo {\n    font-size: 10.8em;\n  }\n  .index-page .rellax-text-container .h1-seo {\n    font-size: 6.9em;\n  }\n}\n\n@media screen and (min-width: 768px) {\n  .presentation-page .card-container:hover .front {\n    top: -80px;\n  }\n  .presentation-page .section-content .image-container {\n    height: 400px;\n  }\n  .presentation-page .section-content .image-container img {\n    position: absolute;\n    width: 100%;\n    max-width: 380px;\n  }\n  .presentation-page .section-content .image-container .img-blog {\n    z-index: 4;\n    left: 100px;\n    top: 20px;\n  }\n  .presentation-page .section-content .image-container .img-comments {\n    z-index: 3;\n    left: -100px;\n    top: -40px;\n  }\n}\n\n@media (max-width: 991px) {\n  .fixed-section.affix {\n    position: relative;\n    margin-bottom: 100px;\n  }\n  .presentation-page .section-cards .image-container1,\n  .presentation-page .section-cards .image-container5 {\n    width: 15%;\n    top: -75px;\n  }\n  .presentation-page .section-cards .image-container2,\n  .presentation-page .section-cards .image-container4 {\n    width: 21%;\n    top: -62px;\n  }\n  .presentation-page .section-cards .image-container3 {\n    width: 22%;\n    top: -45px;\n  }\n}\n\n@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {\n  .presentation-page .section-icons .icons-nucleo {\n    position: initial;\n  }\n  .presentation-page .third-right-icon,\n  .presentation-page .fourth-right-icon,\n  .presentation-page .fifth-right-icon,\n  .presentation-page .sixth-right-icon,\n  .presentation-page .seventh-right-icon,\n  .presentation-page .eighth-right-icon,\n  .presentation-page .ninth-right-icon,\n  .presentation-page .tenth-right-icon,\n  .presentation-page .second-left-icon,\n  .presentation-page .third-left-icon,\n  .presentation-page .fifth-left-icon,\n  .presentation-page .sixth-left-icon,\n  .presentation-page .eighth-left-icon,\n  .presentation-page .fourth-left-icon,\n  .presentation-page .ninth-left-icon,\n  .presentation-page .tenth-left-icon {\n    display: none;\n  }\n  .presentation-page .section-icons .icons-nucleo .first-right-icon,\n  .presentation-page .section-icons .icons-nucleo .first-left-icon {\n    top: -15%;\n  }\n  .presentation-page .section-icons .icons-nucleo .second-right-icon {\n    top: 35%;\n    right: 80%;\n  }\n  .presentation-page .section-content .image-container {\n    height: 550px;\n  }\n  .index-page .category-absolute {\n    top: 90vh;\n  }\n  .footer ul {\n    text-align: left;\n  }\n}\n\n@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {\n  .section-images .hero-images-container,\n  .section-images .hero-images-container-1,\n  .section-images .hero-images-container-2 {\n    margin-top: -15vh;\n    margin-left: 80px;\n  }\n  .section-images .hero-images-container {\n    max-width: 300px;\n  }\n  .section-images .hero-images-container-1 {\n    right: 28%;\n    top: 40%;\n  }\n  .section-images .hero-images-container-2 {\n    right: 21%;\n    top: 55%;\n  }\n  .index-page .category-absolute {\n    top: 90vh;\n  }\n}\n\n@media (max-width: 768px) {\n  .btn,\n  .btn-morphing {\n    margin-bottom: 10px;\n  }\n  .parallax .motto {\n    top: 170px;\n    margin-top: 0;\n    font-size: 60px;\n    width: 270px;\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .presentation-page .section-icons .icons-nucleo {\n    top: -135px;\n  }\n  .presentation-page .section-icons .icons-nucleo.icons-nucleo-right {\n    top: 0;\n  }\n  .presentation-page .first-right-icon,\n  .presentation-page .second-right-icon,\n  .presentation-page .third-right-icon,\n  .presentation-page .fourth-right-icon,\n  .presentation-page .fifth-right-icon,\n  .presentation-page .sixth-right-icon,\n  .presentation-page .seventh-right-icon,\n  .presentation-page .eighth-right-icon,\n  .presentation-page .ninth-right-icon,\n  .presentation-page .tenth-right-icon,\n  .presentation-page .second-left-icon,\n  .presentation-page .third-left-icon,\n  .presentation-page .fifth-left-icon,\n  .presentation-page .sixth-left-icon,\n  .presentation-page .eighth-left-icon {\n    display: none;\n  }\n  .presentation-page .section-icons .icons-nucleo .first-left-icon {\n    left: 2%;\n  }\n  .presentation-page .section-icons .icons-nucleo .fourth-left-icon {\n    left: 46%;\n  }\n  .presentation-page .section-icons .icons-nucleo .seventh-left-icon {\n    left: 80%;\n    font-size: 55px;\n  }\n  .presentation-page .section-icons .icons-nucleo .ninth-left-icon {\n    left: 28%;\n  }\n  .presentation-page .section-icons .icons-nucleo .tenth-left-icon {\n    left: 65%;\n  }\n  .presentation-page .testimonials-people img {\n    position: relative;\n    display: none;\n  }\n  .presentation-page .section-content .image-container {\n    margin-bottom: 45px;\n  }\n  .presentation-page .section-content img {\n    margin-bottom: 15px;\n  }\n}\n\n@media screen and (min-width: 768px) {\n  .presentation-page .section-sections .row {\n    margin-left: -30px;\n    margin-right: -30px;\n  }\n  .presentation-page .section-sections .rellax {\n    left: 60px;\n    position: absolute !important;\n    z-index: 4 !important;\n    box-shadow: 0px 8px 50px 0px rgba(0, 0, 0, 0.4);\n  }\n}\n\n@media screen and (max-width: 576px) {\n  #images img {\n    max-width: 50%;\n    margin-bottom: 15px;\n  }\n}\n\n/*       Loading dots  */\n\n#images h4 {\n  margin-bottom: 30px;\n}\n\n#javascriptComponents {\n  padding-bottom: 0;\n}\n\n/*      layer animation          */\n\n.layers-container {\n  display: block;\n  margin-top: 50px;\n  position: relative;\n}\n\n.layers-container img {\n  position: absolute;\n  width: 100%;\n  height: auto;\n  top: 0;\n  left: 0;\n  text-align: center;\n}\n\n.animate {\n  transition: 1.5s ease-in-out;\n  -moz-transition: 1.5s ease-in-out;\n  -webkit-transition: 1.5s ease-in-out;\n}\n\n.navbar-default.navbar-small .logo-container .brand {\n  color: #333333;\n}\n\n.navbar-transparent.navbar-small .logo-container .brand {\n  color: #FFFFFF;\n}\n\n.navbar-default.navbar-small .logo-container .brand {\n  color: #333333;\n}\n\n.sharing-area {\n  margin-top: 80px;\n}\n\n.sharing-area .btn {\n  margin: 15px 4px 0;\n}\n\n.section-thin,\n.section-notifications {\n  padding: 0;\n}\n\n.section-navbars {\n  padding-top: 0;\n}\n\n#navbar .navbar {\n  margin-bottom: 20px;\n}\n\n#navbar .navbar-toggler,\n#menu-dropdown .navbar-toggler {\n  pointer-events: none;\n}\n\n.section-tabs {\n  background: #ebebeb;\n}\n\n.section-pagination {\n  padding-bottom: 0;\n}\n\n.section-download {\n  padding-top: 130px;\n}\n\n.section-download .description {\n  margin-bottom: 60px;\n}\n\n.section-download h4 {\n  margin-bottom: 25px;\n}\n\n.section-examples a {\n  text-decoration: none;\n}\n\n.section-examples a+a {\n  margin-top: 30px;\n}\n\n.section-examples h5 {\n  margin-top: 30px;\n}\n\n.components-page .wrapper>.header,\n.tutorial-page .wrapper>.header {\n  height: 500px;\n  padding-top: 128px;\n  background-size: cover;\n  background-position: center center;\n}\n\n.components-page .title,\n.tutorial-page .title {\n  color: #FFFFFF;\n}\n\n.invision-logo {\n  max-width: 70px;\n  top: -2px;\n  position: relative;\n}\n\n.creative-tim-logo {\n  max-width: 140px;\n  top: -2px;\n  position: relative;\n}\n\n.section-javascript .title {\n  margin-bottom: 0;\n}\n\n.navbar .switch-background {\n  display: block;\n}\n\n.navbar-transparent .switch-background {\n  display: none;\n}\n\n.section-signup .col .btn {\n  margin-top: 30px;\n}\n\n#buttons-row .btn {\n  margin-bottom: 10px;\n}\n\n@media screen and (max-width: 991px) {\n  .section-navbars .navbar-collapse,\n  .header-1 .navbar-collapse,\n  .header-2 .navbar-collapse,\n  .header-3 .navbar-collapse {\n    display: none !important;\n  }\n  .presentation-page .section-basic-components .image-container {\n    height: 425px;\n    margin-top: 100px;\n  }\n  .presentation-page .section-basic-components .image-container .components-macbook {\n    width: 100%;\n    height: 100%;\n    position: relative;\n    left: 0;\n  }\n  .presentation-page .section-free-demo .github-background-container {\n    position: initial;\n    left: 0;\n    top: 0;\n    max-width: 400px;\n    margin: 0 auto;\n    text-align: center;\n  }\n  .presentation-page .section-free-demo .github-background-container i {\n    font-size: 400px;\n  }\n  .presentation-page .section-components .col-md-3 {\n    padding-left: 15px;\n  }\n  .presentation-page .h3-description,\n  .presentation-page .index-page .h3-description {\n    top: 53%;\n  }\n}\n\n@media (max-width: 1200px) and (min-width: 991px) {\n  .presentation-page .section-basic-components .image-container {\n    height: 326px;\n    margin-top: 30px;\n  }\n  .presentation-page .section-basic-components .image-container .social-img {\n    height: 48px;\n  }\n  .presentation-page .rellax-text-container,\n  .index-page .rellax-text-container {\n    max-width: 900px;\n    top: 27%;\n  }\n  .index-page .rellax-text-container {\n    top: 23%;\n  }\n  .presentation-page .rellax-text-container .pro {\n    font-size: 18px;\n    top: 29px;\n    right: -29px;\n  }\n  .presentation-page .rellax-text-container .h1-seo {\n    font-size: 14em;\n  }\n  .index-page .rellax-text-container .h1-seo {\n    font-size: 9em;\n  }\n}\n\n.burger-menu .section-navbars .navbar-collapse {\n  display: none !important;\n}\n\n.section-basic {\n  padding-top: 0;\n}\n\n.section-images {\n  padding-bottom: 0;\n  z-index: 2;\n}\n\n@-webkit-keyframes Floatingy {\n  from {\n    -webkit-transform: translate(0, 0px);\n  }\n  65% {\n    -webkit-transform: translate(50px, 0);\n  }\n  to {\n    -webkit-transform: translate(0, 0px);\n  }\n}\n\n@-moz-keyframes Floatingy {\n  from {\n    -moz-transform: translate(0, 0px);\n  }\n  65% {\n    -moz-transform: translate(50px, 0);\n  }\n  to {\n    -moz-transform: translate(0, 0px);\n  }\n}\n\n@-webkit-keyframes Floatingx {\n  from {\n    -webkit-transform: translate(50px, 0px);\n  }\n  65% {\n    -webkit-transform: translate(0, 0);\n  }\n  to {\n    -webkit-transform: translate(50px, 0px);\n  }\n}\n\n@-moz-keyframes Floatingx {\n  from {\n    -moz-transform: translate(50px, 0px);\n  }\n  65% {\n    -moz-transform: translate(0, 0);\n  }\n  to {\n    -moz-transform: translate(50px, 0px);\n  }\n}\n\n.table-img,\n.coloured-card-img,\n.coloured-card-btn-img,\n.linkedin-btn-img,\n.share-btn-img,\n.social-img {\n  -webkit-animation-iteration-count: infinite;\n  -webkit-animation-timing-function: ease-in-out;\n  -moz-animation-iteration-count: infinite;\n  -moz-animation-timing-function: ease-in-out;\n  -webkit-animation-name: Floatingy;\n  -moz-animation-name: Floatingy;\n  float: left;\n}\n\n.table-img {\n  -webkit-animation-duration: 14s;\n  -moz-animation-duration: 14s;\n  -webkit-animation-name: Floatingx;\n  -moz-animation-name: Floatingx;\n}\n\n.coloured-card-img {\n  -webkit-animation-duration: 10s;\n  -moz-animation-duration: 10s;\n}\n\n.coloured-card-btn-img {\n  -webkit-animation-duration: 18s;\n  -moz-animation-duration: 18s;\n}\n\n.linkedin-btn-img {\n  -webkit-animation-duration: 15s;\n  -moz-animation-duration: 15s;\n  -webkit-animation-name: Floatingx;\n  -moz-animation-name: Floatingx;\n}\n\n.share-btn-img {\n  -webkit-animation-duration: 11s;\n  -moz-animation-duration: 11s;\n}\n\n.social-img {\n  -webkit-animation-duration: 16s;\n  -moz-animation-duration: 16s;\n  -webkit-animation-name: Floatingx;\n  -moz-animation-name: Floatingx;\n}\n\n.bd-example .btn {\n  margin: 5px 0;\n}\n\n.offline-doc .page-header {\n  display: flex;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
